import React from 'react';
import Intro from '../components/Intro';

const Home = () => {
  return <Intro></Intro>;
};

export default Home;
